import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cf05fc3a")

_pushScopeId("data-v-cf05fc3a")
const _hoisted_1 = { id: "document-browser-sidebar" }
const _hoisted_2 = {
  id: "document-icons-container",
  class: "p-d-flex p-flex-row p-jc-around "
}
const _hoisted_3 = { class: "p-m-4" }
const _hoisted_4 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "p-m-4"
}
const _hoisted_6 = { class: "p-m-0" }
const _hoisted_7 = { class: "p-m-0" }
const _hoisted_8 = {
  key: 2,
  class: "p-m-4"
}
const _hoisted_9 = { class: "p-m-0" }
const _hoisted_10 = { class: "p-m-0" }
const _hoisted_11 = {
  key: 3,
  class: "p-m-4"
}
const _hoisted_12 = { class: "p-m-0" }
const _hoisted_13 = { class: "p-m-0" }
const _hoisted_14 = {
  key: 4,
  class: "p-m-4"
}
const _hoisted_15 = { class: "p-m-0" }
const _hoisted_16 = { class: "p-m-0" }
const _hoisted_17 = {
  key: 5,
  class: "p-m-4"
}
const _hoisted_18 = { class: "p-m-0" }
const _hoisted_19 = { class: "p-m-0" }
const _hoisted_20 = {
  key: 6,
  class: "p-m-4"
}
const _hoisted_21 = { class: "p-m-0" }
const _hoisted_22 = { class: "p-m-0" }
const _hoisted_23 = {
  key: 7,
  class: "p-m-4"
}
const _hoisted_24 = { class: "p-m-0" }
const _hoisted_25 = { class: "p-m-0" }
const _hoisted_26 = {
  key: 8,
  class: "p-m-4"
}
const _hoisted_27 = { class: "p-m-0" }
const _hoisted_28 = { class: "p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, {
      id: "document-detail-toolbar",
      class: "kn-toolbar kn-toolbar--secondary"
    }, {
      start: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.user?.functionalities.includes('DocumentUserManagement'))
            ? _withDirectives((_openBlock(), _createBlock("i", {
                key: 0,
                class: "fa fa-play-circle document-pointer p-mx-4",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.executeDocument && _ctx.executeDocument(...args)))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentBrowser.executeDocument'),
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true),
          (_ctx.canEditDocument)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _withDirectives(_createVNode("i", {
                  class: "pi pi-pencil document-pointer p-mx-4",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showDocumentDetails', _ctx.document)))
                }, null, 512), [
                  [
                    _directive_tooltip,
                    _ctx.$t('documentBrowser.editDocument'),
                    void 0,
                    { top: true }
                  ]
                ]),
                _withDirectives(_createVNode("i", {
                  class: "far fa-copy document-pointer p-mx-4",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cloneDocumentConfirm && _ctx.cloneDocumentConfirm(...args)))
                }, null, 512), [
                  [
                    _directive_tooltip,
                    _ctx.$t('documentBrowser.cloneDocument'),
                    void 0,
                    { top: true }
                  ]
                ]),
                (_ctx.user?.functionalities.includes('DocumentDeleteManagement'))
                  ? _withDirectives((_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "far fa-trash-alt document-pointer p-mx-4",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteDocumentConfirm && _ctx.deleteDocumentConfirm(...args)))
                    }, null, 512)), [
                      [
                        _directive_tooltip,
                        _ctx.$t('documentBrowser.deleteDocument'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.user?.functionalities.includes('DocumentMoveUpState') && _ctx.document.stateCode === 'TEST')
            ? _withDirectives((_openBlock(), _createBlock("i", {
                key: 2,
                class: "fa fa-arrow-up document-pointer p-mx-4",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeStateDocumentConfirm('UP')))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentBrowser.moveUpDocumentState'),
                  void 0,
                  { left: true }
                ]
              ])
            : _createCommentVNode("", true),
          (_ctx.user?.functionalities.includes('DocumentMoveDownState') && (_ctx.document.stateCode === 'TEST' || _ctx.document.stateCode === 'REL'))
            ? _withDirectives((_openBlock(), _createBlock("i", {
                key: 3,
                class: "fa fa-arrow-down document-pointer p-mx-4",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeStateDocumentConfirm('DOWN')))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('documentBrowser.moveDownDocumentState'),
                  void 0,
                  { left: true }
                ]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      (_ctx.selectedDocument?.previewFile)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("img", {
              id: "image-preview",
              src: _ctx.getImageUrl
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.name)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('common.name')), 1),
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.document.name), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.label)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('common.label')), 1),
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.document.label), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.creationUser)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('common.author')), 1),
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.document.creationUser), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.description)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('common.description')), 1),
            _createVNode("p", _hoisted_16, _toDisplayString(_ctx.document.description), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.stateCodeStr)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _createVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('common.state')), 1),
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.document.stateCodeStr), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.typeCode)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t('common.type')), 1),
            _createVNode("p", _hoisted_22, _toDisplayString(_ctx.document.typeCode), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.creationDate)
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            _createVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t('common.creationDate')), 1),
            _createVNode("p", _hoisted_25, _toDisplayString(_ctx.getFormatedDate(_ctx.document.creationDate)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.visible)
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _createVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t('common.visibility')), 1),
            _createVNode("p", _hoisted_28, _toDisplayString(_ctx.document.visible ? _ctx.$t('common.visible') : _ctx.$t('common.notVisible')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})